
import Vue from "vue";
import { Component, Watch } from "vue-property-decorator";
import TextInput from "@/components/Reusable/CustomInputs/TextInput.vue";
import { singularityStore } from "@/store/store";
import WPPageManagerPageNew from "./WPPageManagerPageNew.vue";
import WPPageManagerAddPageWizard from "./WPPageManagerAddPageWizard.vue";
import Dropdown from "@/components/Reusable/Dropdown/Dropdown.vue";
import IconButton from "@/components/UI/IconButton.vue";
import SingularityPanelHeader from "../PanelHeader/SingularityPanelHeader.vue";
import NiceButton from "@/components/UI/NiceButton.vue";
import Icon from "@/components/UI/Icon.vue";
import draggable from "vuedraggable";
import { syncMenuWithPages } from "@/lib/singularity/wp-page-manager/pages";
import { PageInWP } from "@/lib/singularity/wp-page-manager/types";
import SingularityTooltip from "../components/SingularityTooltip.vue";
import { logEvent } from "@/util/tracking";

@Component({
  components: {
    TextInput,
    WPPageManagerPageNew,
    WPPageManagerAddPageWizard,
    Dropdown,
    IconButton,
    SingularityPanelHeader,
    NiceButton,
    Icon,
    draggable,
    SingularityTooltip
  }
})
export default class WPPageManager extends Vue {
  pagesInMenu: PageInWP[] = [];
  otherPages: PageInWP[] = [];
  addIsOpen = false;
  menuSaving = false;
  menuSaved = false;
  initialLoadComplete = false;

  mounted() {
    this.updateLocalPageLists();
    this.$nextTick(() => {
      this.initialLoadComplete = true;
    });
  }

  get isOpeningPage() {
    return singularityStore.isOpeningPageId;
  }

  get pages() {
    return singularityStore.pagesInWP.filter(page => page.postType === "page");
  }

  updateLocalPageLists() {
    const pages = this.pages;

    this.pagesInMenu = pages
      .filter(page => page.isInMainMenu)
      .sort((a, b) => {
        const aOrder = a.menuOrder || 0;
        const bOrder = b.menuOrder || 0;
        return aOrder - bOrder;
      });

    this.otherPages = pages.filter(page => !page.isInMainMenu);
    logEvent("FutureLayer WP Page Manager: Local Page Lists Updated");
  }

  saveInProgress = false;
  @Watch("pagesInMenu", { deep: true })
  async onMenuPagesChanged() {
    if (this.initialLoadComplete) {
      this.saveInProgress = true;
      const menuPageIds = this.pagesInMenu.map(page => page.id);
      await syncMenuWithPages(menuPageIds);
      this.saveInProgress = false;
    }
  }

  handlePageDeleted(pageId: number) {
    this.pagesInMenu = this.pagesInMenu.filter(page => page.id !== pageId);
    this.otherPages = this.otherPages.filter(page => page.id !== pageId);
  }

  openAdd() {
    this.addIsOpen = true;
    logEvent("FutureLayer WP Page Manager: Open Add Page");
  }

  closeAdd() {
    this.addIsOpen = false;
    this.updateLocalPageLists();
  }
}
